import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  SKILL_OPTIONS,
  SkillAbilityOverrideFeature,
} from "@dndModels";
import { 
  ABILITY_SCORES,
} from "@dndModels/Constants";
import { AbilityScoreType } from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  obj: SkillAbilityOverrideFeature;
  change_time: number;
  disabled: boolean;
  onChange: (changed: SkillAbilityOverrideFeature) => void; 
}

export default function SkillAbilityOverrideFeatureInput({ 
  obj,
  change_time,
  disabled,
  onChange
}: Props) {
  const [prev_change_time, setChangeTime] = useState(change_time);
  const [my_obj, setObj] = useState(obj);

  useEffect(() => {
    if (change_time !== prev_change_time) {
      setChangeTime(change_time);
    }
    // eslint-disable-next-line
  }, [change_time]);

  return (
    <Grid container spacing={0} direction="column">
      <Grid>
        <SelectStringBox 
          name="Ability Score" 
          options={ABILITY_SCORES}
          value={obj.ability_score} 
          disabled={disabled}
          onChange={(changed: AbilityScoreType) => {
            const new_obj = my_obj;
            new_obj.ability_score = changed;
            onChange(new_obj);
            setObj(new_obj);
          }} 
        />
      </Grid>
      <Grid>
        <SelectStringBox 
          name="Skills" 
          options={SKILL_OPTIONS}
          multiple
          values={obj.skill_ids} 
          disabled={disabled}
          // log_it
          onChange={(changed: string[]) => {
            const new_obj = my_obj;
            new_obj.skill_ids = changed;
            onChange(new_obj);
            setObj(new_obj);
          }} 
        />
      </Grid>
    </Grid>
  );
}
